import React, { useState } from "react";
import { SectionLabel } from "utility/Constant";

export default function ProductPriceDetails({ Details, secMetalDetail, stoneDetail }) {
  const [expanded, setExpanded] = useState(true);

  const stoneTotal = (stoneDetail || []).reduce(
    (sum, s) => sum + (parseFloat(s.totalValue) || 0),
    0
  );

  const taxTotal = (
    (Details.saleTaxList?.[0]?.amount || 0) +
    (Details.saleTaxList?.[1]?.amount || 0) +
    parseFloat(Details.secGoldTax || 0) +
    (Details.diamondTax || 0) +
    (Details.platinumTax || 0)
  );

  const subTotal =
    (Details.basePrice || 0) +
    (Details.diamondTotal || 0) +
    (Details.platinumTotal || 0) +
    (Details.secGoldTotal || 0);

  const hallmarkTotal =
    Details.hallmarkCharge > 0
      ? Details.hallmarkCharge + Details.hallmarkCharge * ((Details.hmTaxPercentage || 0) / 100)
      : 0;

  const grandTotal = (Details.total && Details.pieceRate > 0) ? Details.total.toFixed(2) : (Details.total && Details.pieceRate <= 0) ? Math.trunc(Details.total) : 0;

  const todayMetalRate = Details.pieceRate > 0 ? 0 :  Details.productTypeName.toLowerCase() === 'gold' ?  Details.goldNet * Details.todayRate : Details.silverNet * Details.todayRate

  const Row = ({ label, value, highlight, accent }) => (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "10px 0",
      borderBottom: "1px solid #f3edf9",
    }}>
      <span style={{
        fontSize: 13, fontWeight: highlight ? 700 : 500,
        color: highlight ? "#2e240d" : "#82775c",
        textTransform: "capitalize",
      }}>
        {label}
      </span>
      <span style={{
        fontSize: highlight ? 15 : 13,
        fontWeight: highlight ? 700 : 600,
        color: accent ? "#ad8b3a" : highlight ? "#6b5330" : "#60553a",
        fontFamily: highlight ? "Cormorant Garamond, Georgia, serif" : "inherit",
      }}>
        {value}
      </span>
    </div>
  );

  return (
    <div>
      <SectionLabel>Price Details</SectionLabel>

      {/* Breakdown toggle */}
      <button
        onClick={() => setExpanded((v) => !v)}
        style={{
          width: "100%",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "10px 14px",
          background: expanded ? "#f5f0fa" : "#faf7fd",
          border: "1px solid #f8efd9",
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 12.5, fontWeight: 700, letterSpacing: ".06em",
          color: "#6b5330",
          textTransform: "uppercase",
          transition: "background .14s",
          marginBottom: expanded ? 0 : 0,
        }}
      >
        <span>Price Breakdown</span>
        <svg
          width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5"
          style={{ transform: expanded ? "rotate(180deg)" : "none", transition: "transform .2s" }}
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {expanded && (
        <div style={{
          border: "1px solid #f8efd9",
          borderTop: "none",
          borderRadius: "0 0 10px 10px",
          padding: "4px 16px 4px",
          background: "#fdfbff",
        }}>
          {todayMetalRate > 0 && 
          <Row
            label={Details.metalType || "Metal"}
            value={`₹${todayMetalRate?.toFixed(2) || "0.00"}`}
          />
          }
          {Details.wastageCost > 0 &&
          <Row
            label={'Wastage'}
            value={`₹${Details.wastageCost?.toFixed(2) || "0.00"}`}
          />
          }
          {Details.makingCost > 0 && 
          <Row
            label={'Making Charge'}
            value={`₹${Details.makingCost?.toFixed(2) || "0.00"}`}
          />
          }
          {/* {secMetalDetail && secMetalDetail.length > 0 && (
            <Row
              label={secMetalDetail[0].productTypeName || "Secondary Metal"}
              value={`₹${((Details.diamondTotal || 0) + (Details.platinumTotal || 0) + (Details.secGoldTotal || 0)).toFixed(2)}`}
            />
          )} */}
          {stoneTotal > 0 && (
            <Row
              label="Stone Value"
              value={`₹${stoneTotal.toFixed(2)}`}
            />
          )}
          <Row
            label="Sub-Total"
            value={`₹${subTotal.toFixed(2)}`}
          />
          <Row
            label="Tax (3%)"
            value={`₹${taxTotal.toFixed(2)}`}
          />
          {hallmarkTotal > 0 && (
            <Row
              label={Details.hmTaxPercentage > 0 ? "Hallmark (with tax)" : "Hallmark Charge"}
              value={`₹${hallmarkTotal.toFixed(2)}`}
            />
          )}
          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "12px 0 8px",
          }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#2e240d", textTransform: "capitalize" }}>
              Grand Total
            </span>
            <span style={{
              fontSize: 16, fontWeight: 700,
              color: "#ad8b3a",
              // fontFamily: "Cormorant Garamond, Georgia, serif",
            }}>
              ₹{grandTotal.toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      )}

       {/* Grand total card */}
      <div style={{
        background: "linear-gradient(135deg, #6b5330 0%, #ad8b3a 100%)",
        borderRadius: 14,
        padding: "18px 20px",
        marginBottom: 14,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <div>
          <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: ".12em", textTransform: "uppercase", color: "rgba(255,255,255,.65)", margin: "0 0 4px" }}>
            Grand Total
          </p>
          <p style={{ fontSize: 11, color: "rgba(255,255,255,.5)", margin: 0, fontStyle: "italic" }}>
            *Inclusive of all taxes
          </p>
        </div>
        <div style={{
          // fontFamily: "Cormorant Garamond, Georgia, serif",
          fontSize: "clamp(26px,3vw,34px)",
          fontWeight: 700,
          color: "#fff",
          letterSpacing: ".01em",
        }}>
          ₹{grandTotal.toLocaleString("en-IN")}
        </div>
      </div>
    </div>
  );
}